(() => {
  if (window.damasciWeddingGalleryMedia) return;
  window.damasciWeddingGalleryMedia = true;
  const initialized = new WeakSet();
  const setAttribute = (element, name, value) => {
    if (element && element.getAttribute(name) !== value) element.setAttribute(name, value);
  };

  function initialize() {
    document.querySelectorAll('[data-wedding-variant-prices]').forEach(data => {
      const card = data.closest('.card-wrapper');
      if (!card || initialized.has(card)) return;
      initialized.add(card);
      const variants = JSON.parse(data.textContent);
      const media = card.querySelector('.card--image-animate');
      if (!media) return;
      const primary = media.querySelector('picture img');
      let secondary = media.querySelector('[data-wedding-secondary]');

      function synchronize() {
        const link = card.querySelector('a[href*="variant="]');
        if (!link) return;
        const id = new URL(link.href, location.origin).searchParams.get('variant');
        const variant = variants[id];
        if (!variant || !variant.image || !primary) return;
        setAttribute(primary, 'src', variant.image);
        setAttribute(primary, 'srcset', variant.image);
        setAttribute(primary, 'data-srcset', variant.image);
        setAttribute(primary.closest('picture'), 'data-hq', variant.image);
        // Keep every responsive source in sync if another component supplies one.
        primary.closest('picture').querySelectorAll('source').forEach(source => setAttribute(source, 'srcset', variant.image));

        if (variant.secondary) {
          if (!secondary) {
            secondary = document.createElement('picture');
            secondary.className = 'motion-reduce';
            secondary.setAttribute('data-wedding-secondary', '');
            const image = document.createElement('img');
            image.className = 'motion-reduce';
            image.loading = 'lazy';
            image.width = image.height = 750;
            secondary.append(image);
            media.append(secondary);
          }
          const image = secondary.querySelector('img');
          setAttribute(image, 'src', variant.secondary);
          setAttribute(image, 'srcset', variant.secondary);
          setAttribute(image, 'alt', primary.alt + ' — upright view');
        } else if (secondary) {
          secondary.remove();
          secondary = null;
        }
        setAttribute(card, 'data-wedding-gallery-variant', id);
        setAttribute(card, 'data-wedding-gallery-metal', variant.metal);
      }

      new MutationObserver(synchronize).observe(card, {
        subtree: true,
        attributes: true,
        attributeFilter: ['href', 'src', 'srcset']
      });
      synchronize();
    });
  }

  new MutationObserver(initialize).observe(document.documentElement, {childList: true, subtree: true});
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, {once:true});
  else initialize();
})();

